module.exports = __webpack_public_path__ + "img/materials.5da1842c.svg";